module.exports = __webpack_public_path__ + "static/media/product.9f37d711.png";